<template>
  <v-dialog v-model="modalConfirmacaoAberto" max-width="500px">
    <v-card>
      <v-card-title class="headline">Confirmar Remoção</v-card-title>
      <v-card-text>
        Deseja remover o evento "{{ eventoSelecionado?.descricao }}"?
        <div v-if="aulasLoading" class="mt-2">
          <v-progress-circular indeterminate size="20" color="primary"></v-progress-circular>
          <span class="ml-2">Buscando aulas vinculadas...</span>
        </div>
        <div v-else-if="aulasVinculadas.length > 0" class="mt-2">
          <strong>Atenção:</strong> Existem {{ aulasVinculadas.length }} aula(s) vinculada(s) a este
          evento.
          <template v-if="totalConfirmadas > 0">
            <br /><strong>{{ totalConfirmadas }}</strong> aula(s) estão com situação
            <strong>Confirmada</strong>.
          </template>
          <br />Considere alterar a data dessas aulas antes de excluir o evento.
        </div>
        <div v-else class="mt-2">Nenhuma aula vinculada ao período deste evento.</div>
      </v-card-text>
      <v-card-actions class="pb-6">
        <v-btn color="red" @click="confirmarRemocao" :disabled="aulasLoading || loading">
          <v-progress-circular
            v-if="loading"
            indeterminate
            size="20"
            color="white"
          ></v-progress-circular>
          <span v-else class="white--text">Remover</span>
        </v-btn>
        <v-btn dark color="grey" @click="fecharModal" :disabled="loading">Cancelar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modalConfirmacaoAberto: Boolean,
    eventoSelecionado: Object,
    loading: Boolean,
  },
  data() {
    return {
      aulasVinculadas: [],
      aulasLoading: false,
    };
  },
  computed: {
    totalConfirmadas() {
      return this.aulasVinculadas.filter((a) => a.situacao === "Aula confirmada").length;
    },
  },
  watch: {
    modalConfirmacaoAberto(val) {
      if (val) {
        this.buscarAulasVinculadas();
      } else {
        this.aulasVinculadas = [];
      }
    },
    eventoSelecionado: {
      handler(val) {
        if (this.modalConfirmacaoAberto && val?.start && val?.end) {
          this.buscarAulasVinculadas();
        }
      },
      deep: true,
    },
  },
  methods: {
    async buscarAulasVinculadas() {
      this.aulasLoading = true;
      try {
        const response = await this.$services.aulasService.getAulasEvento(
          this.eventoSelecionado.id
        );

        this.aulasVinculadas = response?.data || [];
      } catch (error) {
        this.aulasVinculadas = [];
      }
      this.aulasLoading = false;
    },
    confirmarRemocao() {
      this.$emit("confirmar-remocao");
    },
    fecharModal() {
      this.$emit("fechar-modal");
    },
  },
};
</script>
